import { render, staticRenderFns } from "./GraphDetail06.vue?vue&type=template&id=453444bc&scoped=true"
import script from "./GraphDetail06.vue?vue&type=script&lang=js"
export * from "./GraphDetail06.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453444bc",
  null
  
)

export default component.exports